<template>
  <b-row>
    <b-col cols="12">
      <b-card>
        <form-company
          :edit="edit"
          :data-form="getDataCompany"
        />
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
import { BRow, BCol, BCard } from 'bootstrap-vue'
import FormCompany from '@/views/page/account/form/Company.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    FormCompany,
  },
  data() {
    return {
      edit: false,
    }
  },
  computed: {
    ...mapGetters('auth', {
      getDataCompany: 'getMyCompany',
    }),
  },
  mounted() {
  },
  methods: {
  },
}
</script>
